import React from "react";
import AppFooterWeb from "../../components/AppFooterWeb";
import ReactHlsPlayer from "react-hls-player";

export class Stories extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  videos = [
    {
      title: "The impact of Electric Factory concerts",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119969/hls-119969.m3u8",
    },
    {
      title: "Clapton, Beatles, Stones – Early US tours and Electric Factory",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119970/hls-119970.m3u8",
    },
    {
      title: "Promoting shows in the early days",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119971/hls-119971.m3u8",
    },
    {
      title: "Larry Magid on memorable events and Live Aid",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119972/hls-119972.m3u8",
    },
    {
      title: "Artist performance – Past and Present",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119974/hls-119974.m3u8",
    },
    {
      title:
        "Thoughts on moving on from Electric Factory and working with Bruce Springsteen",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119975/hls-119975.m3u8",
    },
    {
      title: "Electric Factory alumni and carrying the legacy forward",
      description: "Larry Magid of Electric Factory",
      source:
        "https://ciright-movie-video-dest.s3.amazonaws.com/119976/hls-119976.m3u8",
    },
  ];

  render() {
    return (
      <>
        <div className="banner-section">
          <div className="banner-stories">
            <div className="Electrified-Stories">
              <p>Electrified Stories</p>
            </div>
            {this.videos.map((video, index) => (
              <div className="stories-blackbg" key={index}>
                <div className="stories-video">
                  <ReactHlsPlayer
                    src={video.source}
                    autoPlay={false}
                    controls={true}
                    width="100%"
                    height="auto"
                    onPlay={(e) => {
                      const videoElements =
                        document.getElementsByTagName("video");
                      for (var i = 0; i < videoElements.length; i++) {
                        if (videoElements.item(i) !== e.target) {
                          videoElements.item(i).pause();
                        }
                      }
                    }}
                  />
                  <div className="stories-title">
                    <h4>{video.title}</h4>
                    <p>{video.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default Stories;
